<div class="confirm-container">
  <img class="cross-icon" src="assets/img/cross.png" [mat-dialog-close] />
  <div class="d-flex flex-column align-items-center justify-content-center w-100">
    <div class="icon d-flex justify-content-center align-items-center mt-3"><span class="confirm-icon"></span></div>
    <div class="confirm-title mt-3">
      {{ "common.receipt.confirmClaim" | translate }}
    </div>
    <div class="confirm-txt mt-2" [innerHTML]="'common.receipt.confirmTxt' | translate"></div>
    <hr class="w-100" />
    <button class="submit-btn" (click)="submit()" [mat-dialog-close]="submitClaim">
      {{ "common.submit" | translate }}
    </button>
    <button class="cancel--btn mt-2" [mat-dialog-close]>
      {{ "common.back" | translate }}
    </button>
  </div>
</div>